/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

// const $el = $(el);
document.getElementById('limit').addEventListener('change', function(event) {
    event.preventDefault();

    let params = new URLSearchParams(window.location.search);
    params.set('limit', this.value);

    window.location.search = params;
});

const limits = [10, 20, 30];
let limit = new URLSearchParams(window.location.search).get('limit');

if (limit) {
    limit = parseInt(limit);
    document.getElementById('limit').value = limits.indexOf(limit) != -1 ? limit : 10;
}